import { render, staticRenderFns } from "./base-currency-field.vue?vue&type=template&id=2741c365"
import script from "./base-currency-field.ts?vue&type=script&lang=ts&external"
export * from "./base-currency-field.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports